"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

/* eslint-disable class-methods-use-this */
var store = require('./store');

var botList = require('./botlist');

var helpers = require('./helpers');

var storageKey = '_constructorio_is_human';
var humanEvents = ['scroll', 'resize', 'touchmove', 'mouseover', 'mousemove', 'keydown', 'keypress', 'keyup', 'focus'];

var HumanityCheck = /*#__PURE__*/function () {
  function HumanityCheck() {
    var _this = this;

    (0, _classCallCheck2["default"])(this, HumanityCheck);
    this.isHumanBoolean = this.getIsHumanFromSessionStorage(); // Humanity proved, remove handlers to prove humanity

    var remove = function remove() {
      _this.isHumanBoolean = true;
      store.session.set(storageKey, true);
      humanEvents.forEach(function (eventType) {
        helpers.removeEventListener(eventType, remove, true);
      });
    }; // Add handlers to prove humanity


    if (!this.isHumanBoolean) {
      humanEvents.forEach(function (eventType) {
        helpers.addEventListener(eventType, remove, true);
      });
    }
  }

  (0, _createClass2["default"])(HumanityCheck, [{
    key: "getIsHumanFromSessionStorage",
    value: function getIsHumanFromSessionStorage() {
      return !!store.session.get(storageKey) || false;
    } // Return boolean indicating if is human

  }, {
    key: "isHuman",
    value: function isHuman() {
      return this.isHumanBoolean || !!store.session.get(storageKey);
    } // Return boolean indicating if useragent matches botlist

  }, {
    key: "isBot",
    value: function isBot() {
      if (this.getIsHumanFromSessionStorage()) {
        return false;
      }

      var _helpers$getNavigator = helpers.getNavigator(),
          userAgent = _helpers$getNavigator.userAgent,
          webdriver = _helpers$getNavigator.webdriver;

      var botRegex = new RegExp("(".concat(botList.join('|'), ")"));
      return Boolean(userAgent.match(botRegex)) || Boolean(webdriver);
    }
  }]);
  return HumanityCheck;
}();

module.exports = HumanityCheck;